module.exports = __webpack_public_path__ + "static/media/video.a09e48ea.mp4";